const PROCTORING_TYPES = {
    INTEGRITY_ADVOCATE: "Integrity Advocate",
    PROCTORIO: "Proctorio"
};

export { PROCTORING_TYPES };
